import {useState, useEffect} from 'react';
import { searchOnEnter, searchOrReset } from '../../components/searchOnEnter';
import Sidebar from '../../components/AdminDashboard/Sidebar';
import TopBar from '../../components/AdminDashboard/TopBar';
import MetaData from '../../layouts/MetaData';
import Loader from '../../layouts/Loader';
import { useDispatch, useSelector} from 'react-redux';
import {Form, InputGroup, DropdownButton, Dropdown } from 'react-bootstrap';
import { 
    getCCMPatients,  
    searchCCMPatient, 
    patientDeActivate,
    patientReactivate,
    getDoctors,
    sortDoctorCCMPatients
} from '../../actions/adminActions';
import { Link, useHistory } from 'react-router-dom';
import { useAlert } from 'react-alert';
import { Table } from 'react-bootstrap';
import IncludeDeactivatedToggle from '../../components/IncludeDeactivatedToggle';
import ReactivatePatientModal from '../../components/ReactivatePatientModal';
import DeactivatePatientModal from '../../components/DeactivatePatientModal';
import { isDeceasedPatient, isSuperAdmin } from '../../utils/deactivationReasons';
import { canReactivatePatient } from '../../utils/patientStatus';
import Pagination from 'react-js-pagination';
import {UPDATE_PATIENT_RESET} from '../../constants/adminConstants';
import { formatClinicianName } from '../../utils/clinicianName';
import CareTeamBulkBar from '../../components/CareTeam/CareTeamBulkBar';
import { applyCareTeamFilter } from '../../components/CareTeam/careTeamText';
import { useSortableTable, SortableTh, personName } from '../../components/SortableTable';
import { formatDob } from '../../utils/dateFormat';

export const PATIENT_SORT_COLUMNS = {
    emrId: { type: 'string', value: (p) => p?.emrId },
    name: { type: 'name', value: personName },
    dob: { type: 'date', value: (p) => p?.DOB },
    status: { type: 'boolean', value: (p) => p?.block },
    provider: { type: 'name', value: (p) => personName(p?.assigned_doctor_id) },
    consent: { type: 'string', value: (p) => p?.patientType },
};
const serverSort = (t) => (t.sortKey && t.sortKey !== 'provider' ? { sortBy: t.sortKey, sortDir: t.sortDir } : null);


const CCMPatients = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    
    const [smShow, setSmShow] = useState(false); //small confirm modal
    const [deactivateTarget, setDeactivateTarget] = useState(null);
    const [patientModel, setPatientModel] = useState(null);

    const alert = useAlert();
    const { loading, error, patients, isUpdated} = useSelector(state => state.admin);
    const { ccmPts } = useSelector(state => state.adminStat)
    const [keyword, setKeyword] = useState('');
    const [searchBy ,setSearchBy] = useState('emrId');
    const [isSearch, setIsSearch] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [resPerPage, setResPerPage] = useState(20);
    const { doctors } = useSelector(state => state.doctor);
    const [doctorId, setDoctorId] = useState('');
    const [includeDeactivated, setIncludeDeactivated] = useState(false);
    const [reactivateTarget, setReactivateTarget] = useState(null);
    const [selectedIds, setSelectedIds] = useState([]);
    const [careFilter, setCareFilter] = useState('');
    const { user } = useSelector(state => state.auth);
    const tableSort = useSortableTable(patients, { id: 'admin.ccmPatients', columns: PATIENT_SORT_COLUMNS, defaultSort: { key: 'name', dir: 'asc' } });
    const careRows = applyCareTeamFilter(tableSort.rows, careFilter);
    const toggleSelected = (id) => setSelectedIds((ids) => (ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]));
    const allVisibleSelected = careRows.length > 0 && careRows.every((p) => selectedIds.includes(p?._id));
    const toggleAllVisible = () => setSelectedIds(allVisibleSelected ? selectedIds.filter((id) => !careRows.some((p) => p?._id === id)) : [...new Set([...selectedIds, ...careRows.map((p) => p?._id)])]);
    const listSort = serverSort(tableSort);

    useEffect(() =>{
        if(error){
            alert.error(error);
            return
        }

        if(isUpdated){
            alert.success('Status Changed');
            dispatch({type: UPDATE_PATIENT_RESET});
            dispatch(getCCMPatients(resPerPage, currentPage, includeDeactivated, listSort));
            setSmShow(false);
        }

        dispatch(getCCMPatients(resPerPage, currentPage, includeDeactivated, listSort));
        dispatch(getDoctors(resPerPage, currentPage));

    }, [dispatch, error, isUpdated, currentPage, includeDeactivated, tableSort.sortKey, tableSort.sortDir]);


        function setCurrentPageNumber(pageNumber) {
            setCurrentPage(pageNumber);
        }

        const searchhandler = () => {
            dispatch(searchCCMPatient(searchBy, keyword));
        }  

        const refreshhandler =() => {
            dispatch(getCCMPatients(resPerPage, currentPage, includeDeactivated, listSort))
        }

        const deActivatePatient = (deactivation) => {
            dispatch(patientDeActivate(patientModel, deactivation));
            setSmShow(false);
        }

        const reactivatePatient = (reason, confirmDeceased) => {
            dispatch(patientReactivate(reactivateTarget?._id, reason, confirmDeceased));
            setReactivateTarget(null);
        }

        const searchPatientByDoctor = (id) => {
            if(id === "undefined" || ''){
                dispatch(getCCMPatients(resPerPage, currentPage, includeDeactivated, listSort));
                dispatch(getDoctors(resPerPage, currentPage));
                return
            }
            dispatch(sortDoctorCCMPatients(id, includeDeactivated));
        }

    return (
        <>
                <MetaData title="Patients List"/>
                <Sidebar />    

                <section className="home-section">
                {/* TopBar */}
                <TopBar />

                {loading ? <Loader /> : (
                <>   
                {/*  patients List Filter Section */}
                <div className="shadow-lg p-3 mb-5 mr-4 ml-4 rounded-card" style={{backgroundColor: '#FAFAFA'}}>
                    <div className="home-content">
                        
                        <div className="row-display">
                            <div className="col-md-8">
                                <h5 style={{color: '#004aad'}}>
                                    <i className="bx bx-user"></i> <strong>&nbsp;{includeDeactivated ? 'All' : 'Active'} CCM Patients </strong>
                                </h5>
                            </div>

                            <button className="btn btn-secondary btn-sm" onClick={() => history.goBack()}>
                                <i className='bx bx-arrow-back' ></i>
                            </button> &nbsp;

                            <Link to ="/Patients/Inactive" className="edit-pill">
                                <i className='bx bxs-user'></i> &nbsp;Inactive Patients
                            </Link>

                            <IncludeDeactivatedToggle checked={includeDeactivated} onChange={setIncludeDeactivated} id="includeDeactivatedCcm" />
                            &nbsp;
                            <Link to="/addpatient" className="edit-pill">
                                <i className='bx bxs-user'></i> &nbsp;Add New Patient
                            </Link>
                                                      
                        </div>
                        <hr />

                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row-display">
                                        <select 
                                            className="form-control select-input-type" 
                                            value={searchBy}
                                            onChange={e => setSearchBy(e.target.value)}
                                            >
                                                <option value="undefined">Filter Patient </option>
                                                <option value="emrId">EHR-ID</option>
                                                <option value="firstname">Firstname</option>
                                                <option value="lastname">Lastname</option>
                                                <option value="email">email</option>
                                                <option value="phone1">phone1</option>
                                                <option value="initialsetup">Initial Month</option>
                                                <option value="diseases">Diseases</option>
                                                <option value="insurancecompany">Ins. Company</option>
                                                <option value="address">Address</option>
                                                <option value="state">State</option>
                                                <option value="city">City</option>
                                                <option value="zipCode">Zip Code</option>
                                        </select>    
                                            &nbsp;
                                            <InputGroup>
                                                <Form.Control
                                                    placeholder="Search here ..."
                                                    aria-label="Search here ..."
                                                    className="form-control"
                                                    value={keyword}
                                                    onChange={e => setKeyword(e.target.value) }
                                                    onKeyDown={searchOnEnter(searchhandler, refreshhandler)}
                                                />
                                                &nbsp;<button className="btn btn-outline-primary btn-sm " id="button-addon2" onClick={() => searchOrReset(keyword, searchhandler, refreshhandler)}>
                                                    <i className='bx bx-search-alt'></i>
                                                </button>
                                                &nbsp;<button className="btn btn-outline-primary btn-sm" id="button-addon2" onClick={refreshhandler}>
                                                    <i className='bx bx-refresh'></i>
                                                </button>
                                                </InputGroup>

                                                    <select 
                                                    className="form-control"
                                                    value={doctorId}
                                                    onChange={(e) => {searchPatientByDoctor(e.target.value); setDoctorId(e.target.value)}}
                                                    >
                                                        <option value="undefined"> Sort By Physician.</option>
                                                        {doctors && doctors.map((doc, index) => (
                                                            <option value={doc?._id} key={index}>{formatClinicianName(doc)}</option>                                         
                                                        ))}
                                                    </select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>  
                                    <br />


                    {/* Patient List Card */}
                        <div className="col-md-12">
                        {patients && <>
                            <CareTeamBulkBar selectedIds={selectedIds} filter={careFilter} onFilterChange={setCareFilter} defaultSlot="ccm" onClear={() => setSelectedIds([])} onDone={() => { setSelectedIds([]); dispatch(getCCMPatients(resPerPage, currentPage, includeDeactivated, listSort)); }} />
                            <Table responsive hover striped bordered>
                            <thead align="center">
                                <tr>
                                <th><input type="checkbox" aria-label="Select all patients" checked={allVisibleSelected} onChange={toggleAllVisible} /></th>
                                <SortableTh sortKey="emrId" sort={tableSort}>EHR - ID</SortableTh>
                                <SortableTh sortKey="name" sort={tableSort}>Name</SortableTh>
                                <SortableTh sortKey="dob" sort={tableSort}>DOB</SortableTh>
                                <SortableTh sortKey="status" sort={tableSort}>Acc Status</SortableTh>
                                <SortableTh sortKey="provider" sort={tableSort} className="text-nowrap">Provider</SortableTh>
                                <SortableTh sortKey="consent" sort={tableSort}>Consent Role</SortableTh>
                                <th>Action</th> 
                                </tr>
                            </thead>
                            <tbody>
                            
                            {patients && patients.length > 0 ? <> 
                                {careRows.map((patient, index) => (
                                <tr key={index}>
                                <td><input type="checkbox" aria-label={`Select ${patient?.lastname}, ${patient?.firstname}`} checked={selectedIds.includes(patient?._id)} onChange={() => toggleSelected(patient?._id)} /></td>
                                <td>{patient?.emrId || 'N/A'}</td>  
                                <td>
                                    {patient?.patientType === 'CCM' ? <Link className="link" 
                                        to={{ pathname: "/patientProfile", state: {patientid: patient?._id}}}>
                                         {patient?.lastname +', '+ patient?.firstname}
                                    </Link> : <Link className="link" to={{ pathname: "/patientProfile", state: {patientid: patient?._id}}}>
                                        {patient?.lastname +', '+ patient?.firstname}
                                        </Link>
                                    }
                                </td>
                                
                                <td> {formatDob(patient?.DOB)} 
                                    <p>{patient?.gender}</p>
                                </td> 
                                
                                <td>
                                   {patient?.block === false ? <span style={{color: 'green', fontWeight: 'bold'}}>Active</span> : <span style={{color: 'red', fontWeight: 'bold'}}>Deactivated</span>}{isDeceasedPatient(patient) && <span className="badge bg-dark text-white ml-1">Deceased</span>}
                                </td> 
                                    
                                {patient?.assigned_doctor_id ? <>
                                <td className="text-nowrap">{formatClinicianName(patient?.assigned_doctor_id)}</td>
                                </> : <>
                                <td>N/A</td>
                                </>}

                                <td>{patient?.patientType}</td>
                                
                                {/* Actions */}
                                <td>
                                <DropdownButton id="dropdown-basic-button" variant="link">
                                    <Dropdown.Item>
                                        {patient?.patientType === 'CCM' ? <Link className="link" to={{ pathname: "/patientprofile/ccm", state: {patientid: patient?._id}}}>View Profile</Link>
                                        : <Link className="link" to={{ pathname: "/patientProfile", state: {patientid: patient?._id}}}>
                                            View Profile
                                        </Link>}
                                    </Dropdown.Item>

                                    <Dropdown.Item>
                                        <Link className="link" to={{pathname: '/Patients/Edit', state: {patientDetails: patient}}}>Edit Details</Link>
                                    </Dropdown.Item>

                                    <Dropdown.Item>
                                        {patient?.block === true ? (canReactivatePatient(user?.role) && <span className="link" style={{color: 'green', cursor: 'pointer'}} onClick={() => setReactivateTarget(patient)}>Reactivate Profile</span>)
                                        : <Link className="link" style={{color: 'red'}} to="/CCM/Patients" onClick={() => {setSmShow(true); setPatientModel(patient?._id); setDeactivateTarget(patient)}}>Deactivate Profile</Link>}
                                    </Dropdown.Item>
                                </DropdownButton>
                                </td>
                            </tr>    
                            ))}
                            </> : <div>
                                <small className="not-found-text">Patients Not Found</small>
                            </div> }
                            
                            </tbody>
                            
                            </Table>
                            <small style={{color: 'gray'}}>Showing {resPerPage} records per page</small> 

                            {/* Pagination */}
                                {!isSearch && resPerPage <= ccmPts && (
                                    <div className="d-flex justify-content-center mt-5"> 
                                    <Pagination activePage={currentPage} 
                                    itemsCountPerPage={resPerPage} 
                                    totalItemsCount = {ccmPts}
                                    onChange={setCurrentPageNumber} 
                                    nextPageText = {'⟩'}
                                    prevPageText = {'⟨'}
                                    firstPageText = {'«'}
                                    lastPageText = {'»'}
                                    itemClass='page-item'
                                    linkClass="page-link"
                                    />           
                            </div>
                                )}    

                                <DeactivatePatientModal
                                    show={smShow}
                                    patient={deactivateTarget}
                                    onCancel={() => setSmShow(false)}
                                    onConfirm={deActivatePatient}
                                />

                                <ReactivatePatientModal
                                    show={!!reactivateTarget}
                                    patientName={reactivateTarget?.lastname}
                                    deceased={isDeceasedPatient(reactivateTarget)}
                                    canOverrideDeceased={isSuperAdmin(user)}
                                    onCancel={() => setReactivateTarget(null)}
                                    onConfirm={reactivatePatient}
                                />
                        </>}                      
                        </div>
                    </div>
                </>
            )}
            </section>
        </>
    )
}

export default CCMPatients
